import { processFarmFields, processAllFarmFields } from './geoJSONHelpers';

/**
 * Handles properties data from API response and updates filtered GeoJSON
 * @param {Object} data - API response data containing properties
 * @param {string} farmId - Optional farm ID to filter by specific farm
 * @param {Function} setFilteredGeoJSON - State setter function for filtered GeoJSON
 */
const handlePropertiesData = (data, farmId, setFilteredGeoJSON) => {
  if (farmId) {
    const farm = data?.properties?.find(prop => prop.id === farmId);
    const formattedGeoJSON = processFarmFields(farm);
    if (formattedGeoJSON) {
      setFilteredGeoJSON(formattedGeoJSON);
    }
  } else {
    const formattedGeoJSON = processAllFarmFields(data?.properties || []);
    if (formattedGeoJSON) {
      setFilteredGeoJSON(formattedGeoJSON);
    }
  }
};

export default handlePropertiesData;
